/*function _0x5d74(){const _0x3a9f58=['GET','100%','right','borderTop','height','success','licenseInfo_','2925ShHiNz','40YTlqom','license-cache-notification','8px','20px','Invalid\x20license\x20key\x20provided','license-loading-overlay','column','setItem','&shop=','16px','0\x204px\x206px\x20rgba(0,0,0,0.1)','innerHTML','40px','then','alignItems','addEventListener','10px\x2015px','status','spin\x201s\x20linear\x20infinite','getElementById','#f39c12','425823USgrkl','-apple-system,\x20BlinkMacSystemFont,\x20\x27Segoe\x20UI\x27,\x20Roboto,\x20Oxygen,\x20Ubuntu,\x20Cantarell,\x20\x27Open\x20Sans\x27,\x20\x27Helvetica\x20Neue\x27,\x20sans-serif','background','animation','getItem','textAlign','remove','No\x20license\x20key\x20provided','4px','white','width','key','style','justifyContent','active','629342vTImte','rgba(0,0,0,0.5)','validatedAt','shop','isValid','appendChild','padding','top','stringify','position','https://elixir-api-ypyufwpzza-uc.a.run.app/api/licenses?action=verify&licenseKey=','16agwaVx','stopPropagation','center','left','\x0a\x20\x20\x20\x20\x20\x20<h2\x20style=\x22color:\x20#e74c3c;\x20margin-bottom:\x2020px;\x22>License\x20Required</h2>\x0a\x20\x20\x20\x20\x20\x20<p\x20style=\x22color:\x20#2c3e50;\x20margin-bottom:\x2020px;\x20line-height:\x201.5;\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20','color','flex','license_key','textContent','click','overflow','zIndex','500px','error','fontSize','24912JotbJG','data','1000','Validating\x20license...','createElement','body','message','undefined','fontFamily','json','div','head','\x0a\x20\x20\x20\x20\x20\x20@keyframes\x20spin\x20{\x0a\x20\x20\x20\x20\x20\x20\x20\x200%\x20{\x20transform:\x20rotate(0deg);\x20}\x0a\x20\x20\x20\x20\x20\x20\x20\x20100%\x20{\x20transform:\x20rotate(360deg);\x20}\x0a\x20\x20\x20\x20\x20\x20}\x0a\x20\x20\x20\x20','1869145gjKZtx','13370SJwLfb','770940EfFflR','fixed','hidden','license-error-overlay','designMode','308BAiUsE','1001','15px','4px\x20solid\x20#3498db','backgroundColor','toISOString','30px','6346848XeayIN','maxWidth','display','License\x20check\x20failed.\x20Please\x20try\x20again\x20later.','auto','borderRadius','71BAKAHJ','flexDirection'];_0x5d74=function(){return _0x3a9f58;};return _0x5d74();}const _0x1caf46=_0x4607;function _0x4607(_0x81a175,_0xf19e91){const _0x5d74e6=_0x5d74();return _0x4607=function(_0x46075b,_0x297f39){_0x46075b=_0x46075b-0x92;let _0x4c3130=_0x5d74e6[_0x46075b];return _0x4c3130;},_0x4607(_0x81a175,_0xf19e91);}(function(_0x152314,_0x4357d3){const _0x3610f8=_0x4607,_0x16bddb=_0x152314();while(!![]){try{const _0x135a17=-parseInt(_0x3610f8(0xb0))/0x1*(parseInt(_0x3610f8(0xf8))/0x2)+-parseInt(_0x3610f8(0xcf))/0x3*(parseInt(_0x3610f8(0xe9))/0x4)+parseInt(_0x3610f8(0x9c))/0x5+-parseInt(_0x3610f8(0xaa))/0x6+parseInt(_0x3610f8(0xde))/0x7*(parseInt(_0x3610f8(0xba))/0x8)+-parseInt(_0x3610f8(0xb9))/0x9*(-parseInt(_0x3610f8(0x9d))/0xa)+parseInt(_0x3610f8(0xa3))/0xb*(parseInt(_0x3610f8(0x9e))/0xc);if(_0x135a17===_0x4357d3)break;else _0x16bddb['push'](_0x16bddb['shift']());}catch(_0x5d1418){_0x16bddb['push'](_0x16bddb['shift']());}}}(_0x5d74,0x857ec));if(Shopify[_0x1caf46(0xa2)]){function validateLicense(_0x5ac4fd,_0x5555cf){const _0x2272be=_0x1caf46;if(!_0x5ac4fd||_0x5ac4fd==='null'||_0x5ac4fd===_0x2272be(0x96)||_0x5ac4fd===''){showInvalidLicense(_0x2272be(0xd6));return;}const _0x1b8261=_0x2272be(0xb8)+_0x5555cf,_0x309b4d=localStorage[_0x2272be(0xd3)](_0x1b8261),_0x30ad91=_0x309b4d?JSON['parse'](_0x309b4d):null;if(_0x30ad91&&_0x30ad91[_0x2272be(0xda)]===_0x5ac4fd&&_0x30ad91[_0x2272be(0xcb)]===_0x2272be(0xdd)&&_0x30ad91[_0x2272be(0xe0)]){const _0x1757a9=new Date(_0x30ad91[_0x2272be(0xe0)]),_0x26ba54=(new Date()-_0x1757a9)/(0x3e8*0x3c*0x3c);if(_0x26ba54<0x18){const _0x39ea6a=document[_0x2272be(0xcd)](_0x2272be(0xa1));_0x39ea6a&&_0x39ea6a[_0x2272be(0xd5)]();document[_0x2272be(0x94)][_0x2272be(0xdb)][_0x2272be(0xf3)]=_0x2272be(0xae);return;}}showLoadingState(_0x2272be(0x92)),fetch(_0x2272be(0xe8)+encodeURIComponent(_0x5ac4fd)+_0x2272be(0xc2)+encodeURIComponent(_0x5555cf),{'method':_0x2272be(0xb2),'headers':{'Content-Type':'application/json'}})['then'](_0x2db4d3=>_0x2db4d3[_0x2272be(0x98)]())[_0x2272be(0xc7)](_0x200143=>{const _0x43d50a=_0x2272be;removeLoadingState();if(_0x200143[_0x43d50a(0xcb)]===_0x43d50a(0xb7)&&_0x200143[_0x43d50a(0xe2)]){localStorage[_0x43d50a(0xc1)](_0x1b8261,JSON[_0x43d50a(0xe6)]({'key':_0x5ac4fd,'status':_0x43d50a(0xdd),'data':_0x200143[_0x43d50a(0xf9)],'validatedAt':new Date()[_0x43d50a(0xa8)]()}));const _0x24ba99=document['getElementById'](_0x43d50a(0xa1));_0x24ba99&&_0x24ba99[_0x43d50a(0xd5)](),document[_0x43d50a(0x94)]['style']['overflow']=_0x43d50a(0xae);}else localStorage['removeItem'](_0x1b8261),showInvalidLicense(_0x200143[_0x43d50a(0x95)]||_0x43d50a(0xbe));})['catch'](_0x4ed9d3=>{const _0x358536=_0x2272be;removeLoadingState(),console[_0x358536(0xf6)]('License\x20validation\x20error:',_0x4ed9d3);if(_0x30ad91&&_0x30ad91[_0x358536(0xe0)]){const _0x2b2c70=new Date(_0x30ad91[_0x358536(0xe0)]),_0x493645=(new Date()-_0x2b2c70)/(0x3e8*0x3c*0x3c);if(_0x493645<0x18){showCachedLicenseWarning();return;}}showInvalidLicense(_0x358536(0xad));});}function showCachedLicenseWarning(){const _0x4bed42=_0x1caf46,_0x2c8f24=document['createElement'](_0x4bed42(0x99));_0x2c8f24['id']=_0x4bed42(0xbb),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xe7)]=_0x4bed42(0x9f),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xe5)]=_0x4bed42(0xbd),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xb4)]=_0x4bed42(0xbd),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xd1)]=_0x4bed42(0xce),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xee)]=_0x4bed42(0xd8),_0x2c8f24['style'][_0x4bed42(0xe4)]=_0x4bed42(0xca),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xaf)]=_0x4bed42(0xd7),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xf7)]='14px',_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0xf4)]=_0x4bed42(0xa4),_0x2c8f24[_0x4bed42(0xdb)][_0x4bed42(0x97)]=_0x4bed42(0xd0),_0x2c8f24[_0x4bed42(0xf1)]='Using\x20cached\x20license\x20data\x20(server\x20unavailable)',document[_0x4bed42(0x94)][_0x4bed42(0xe3)](_0x2c8f24),setTimeout(()=>{_0x2c8f24['parentNode']&&_0x2c8f24['remove']();},0x1388);}function showLoadingState(_0x1b5c1d='Loading...'){const _0x3b5d33=_0x1caf46,_0x1365c1=document['createElement'](_0x3b5d33(0x99));_0x1365c1['id']=_0x3b5d33(0xbf),_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xe7)]=_0x3b5d33(0x9f),_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xe5)]='0',_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xec)]='0',_0x1365c1[_0x3b5d33(0xdb)]['width']='100%',_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xb6)]=_0x3b5d33(0xb3),_0x1365c1['style']['backgroundColor']=_0x3b5d33(0xdf),_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xf4)]=_0x3b5d33(0xfa),_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xac)]='flex',_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xdc)]='center',_0x1365c1['style'][_0x3b5d33(0xc8)]='center',_0x1365c1[_0x3b5d33(0xdb)][_0x3b5d33(0xb1)]=_0x3b5d33(0xc0);const _0x1c78b0=document[_0x3b5d33(0x93)](_0x3b5d33(0x99));_0x1c78b0[_0x3b5d33(0xdb)]['border']='4px\x20solid\x20#f3f3f3',_0x1c78b0[_0x3b5d33(0xdb)][_0x3b5d33(0xb5)]=_0x3b5d33(0xa6),_0x1c78b0[_0x3b5d33(0xdb)][_0x3b5d33(0xaf)]='50%',_0x1c78b0[_0x3b5d33(0xdb)][_0x3b5d33(0xd9)]=_0x3b5d33(0xc6),_0x1c78b0[_0x3b5d33(0xdb)][_0x3b5d33(0xb6)]=_0x3b5d33(0xc6),_0x1c78b0[_0x3b5d33(0xdb)][_0x3b5d33(0xd2)]=_0x3b5d33(0xcc),_0x1c78b0[_0x3b5d33(0xdb)]['marginBottom']=_0x3b5d33(0xa5);const _0xc9306d=document[_0x3b5d33(0x93)]('div');_0xc9306d['style'][_0x3b5d33(0xee)]='white',_0xc9306d[_0x3b5d33(0xdb)][_0x3b5d33(0xf7)]=_0x3b5d33(0xc3),_0xc9306d[_0x3b5d33(0xdb)][_0x3b5d33(0x97)]=_0x3b5d33(0xd0),_0xc9306d['textContent']=_0x1b5c1d;const _0x19ae4c=document[_0x3b5d33(0x93)]('style');_0x19ae4c[_0x3b5d33(0xf1)]=_0x3b5d33(0x9b),document[_0x3b5d33(0x9a)][_0x3b5d33(0xe3)](_0x19ae4c),_0x1365c1['appendChild'](_0x1c78b0),_0x1365c1['appendChild'](_0xc9306d),document['body'][_0x3b5d33(0xe3)](_0x1365c1),document[_0x3b5d33(0x94)][_0x3b5d33(0xdb)][_0x3b5d33(0xf3)]=_0x3b5d33(0xa0);}function removeLoadingState(){const _0x24ffc1=_0x1caf46,_0x190bfd=document[_0x24ffc1(0xcd)](_0x24ffc1(0xbf));_0x190bfd&&_0x190bfd['remove']();}function showInvalidLicense(_0x40ad5e){const _0x862356=_0x1caf46;removeLoadingState();const _0x52c187=document[_0x862356(0xcd)](_0x862356(0xa1));_0x52c187&&_0x52c187['remove']();const _0x17ae0f=document[_0x862356(0x93)](_0x862356(0x99));_0x17ae0f['id']=_0x862356(0xa1),_0x17ae0f[_0x862356(0xdb)]['position']='fixed',_0x17ae0f[_0x862356(0xdb)][_0x862356(0xe5)]='0',_0x17ae0f[_0x862356(0xdb)][_0x862356(0xec)]='0',_0x17ae0f[_0x862356(0xdb)][_0x862356(0xd9)]=_0x862356(0xb3),_0x17ae0f[_0x862356(0xdb)][_0x862356(0xb6)]='100%',_0x17ae0f[_0x862356(0xdb)][_0x862356(0xa7)]=_0x862356(0xdf),_0x17ae0f[_0x862356(0xdb)]['zIndex']='1000',_0x17ae0f[_0x862356(0xdb)]['display']=_0x862356(0xef),_0x17ae0f[_0x862356(0xdb)]['justifyContent']='center',_0x17ae0f[_0x862356(0xdb)][_0x862356(0xc8)]='center';const _0x190b64=document[_0x862356(0x93)](_0x862356(0x99));_0x190b64[_0x862356(0xdb)][_0x862356(0xd1)]='white',_0x190b64[_0x862356(0xdb)][_0x862356(0xe4)]=_0x862356(0xa9),_0x190b64[_0x862356(0xdb)]['borderRadius']=_0x862356(0xbc),_0x190b64[_0x862356(0xdb)]['boxShadow']=_0x862356(0xc4),_0x190b64[_0x862356(0xdb)][_0x862356(0xab)]=_0x862356(0xf5),_0x190b64['style'][_0x862356(0xd4)]=_0x862356(0xeb),_0x190b64['style'][_0x862356(0x97)]=_0x862356(0xd0),_0x190b64[_0x862356(0xc5)]=_0x862356(0xed)+_0x40ad5e+'.\x20Please\x20enter\x20a\x20valid\x20license\x20key\x20under\x20<strong>Theme\x20Settings\x20&gt;\x20License</strong>\x20to\x20continue\x20using\x20this\x20theme.\x0a\x20\x20\x20\x20\x20\x20</p>\x0a\x20\x20\x20\x20',_0x17ae0f[_0x862356(0xe3)](_0x190b64),document[_0x862356(0x94)][_0x862356(0xe3)](_0x17ae0f),document[_0x862356(0x94)][_0x862356(0xdb)][_0x862356(0xf3)]=_0x862356(0xa0),_0x17ae0f[_0x862356(0xc9)](_0x862356(0xf2),_0x2098c3=>{const _0x3f0276=_0x862356;_0x2098c3['preventDefault'](),_0x2098c3[_0x3f0276(0xea)]();});}validateLicense(Shopify[_0x1caf46(0xf0)],Shopify[_0x1caf46(0xe1)]);}
 */
if (Shopify.designMode) {
  function validateLicense(licenseKey, shop) {    
    if (
      !licenseKey ||
      licenseKey === "null" ||
      licenseKey === "undefined" ||
      licenseKey === ""
    ) {
      showInvalidLicense("No license key provided");
      return;
    }

    const licenseStorageKey = `licenseInfo_${shop}`;
    const storedLicenseData = localStorage.getItem(licenseStorageKey);
    const licenseInfo = storedLicenseData ? JSON.parse(storedLicenseData) : null;

    // Check if we have valid cached data that's recent (within 24 hours)
    if (licenseInfo && licenseInfo.key === licenseKey && licenseInfo.status === "active" && licenseInfo.validatedAt) {
      const lastValidated = new Date(licenseInfo.validatedAt);
      const hoursSinceValidation = (new Date() - lastValidated) / (1000 * 60 * 60);
      
      if (hoursSinceValidation < 24) {
        // Use cached data immediately - no API call needed
        const existingOverlay = document.getElementById("license-error-overlay");
        if (existingOverlay) {
          existingOverlay.remove();
        }
        document.body.style.overflow = "auto";
        return;
      }
    }

    // Show loading state with better UX
    showLoadingState("Validating license...");

    // Validate from server (single API call)
    fetch(
      `https://elixir-api-ypyufwpzza-uc.a.run.app/api/licenses?action=verify&licenseKey=${encodeURIComponent(licenseKey)}&shop=${encodeURIComponent(shop)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        removeLoadingState();
        
        if (data.status === "success" && data.isValid) {
          // Store successful license data
          localStorage.setItem(
            licenseStorageKey,
            JSON.stringify({
              key: licenseKey,
              status: "active",
              data: data.data,
              validatedAt: new Date().toISOString()
            })
          );
          // Remove any existing invalid license overlay
          const existingOverlay = document.getElementById("license-error-overlay");
          if (existingOverlay) {
            existingOverlay.remove();
          }
          document.body.style.overflow = "auto";
        } else {
          // Remove invalid license data
          localStorage.removeItem(licenseStorageKey);
          showInvalidLicense(data.message || "Invalid license key provided");
        }
      })
      .catch((error) => {
        removeLoadingState();
        console.error("License validation error:", error);
        
        // If we have cached data and it's recent (within 24 hours), use it
        if (licenseInfo && licenseInfo.validatedAt) {
          const lastValidated = new Date(licenseInfo.validatedAt);
          const hoursSinceValidation = (new Date() - lastValidated) / (1000 * 60 * 60);
          
          if (hoursSinceValidation < 24) {
            // Use cached data but show a subtle warning
            showCachedLicenseWarning();
            return;
          }
        }
        
        showInvalidLicense("License check failed. Please try again later.");
      });
  }
  return

  function showCachedLicenseWarning() {
    // Show a subtle notification that we're using cached data
    const notification = document.createElement("div");
    notification.id = "license-cache-notification";
    notification.style.position = "fixed";
    notification.style.top = "20px";
    notification.style.right = "20px";
    notification.style.background = "#f39c12";
    notification.style.color = "white";
    notification.style.padding = "10px 15px";
    notification.style.borderRadius = "4px";
    notification.style.fontSize = "14px";
    notification.style.zIndex = "1001";
    notification.style.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif";
    notification.textContent = "Using cached license data (server unavailable)";
    
    document.body.appendChild(notification);
    
    // Remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 5000);
  }

  function showLoadingState(message = "Loading...") {
    // Create loading overlay
    const loadingOverlay = document.createElement("div");
    loadingOverlay.id = "license-loading-overlay";
    loadingOverlay.style.position = "fixed";
    loadingOverlay.style.top = "0";
    loadingOverlay.style.left = "0";
    loadingOverlay.style.width = "100%";
    loadingOverlay.style.height = "100%";
    loadingOverlay.style.backgroundColor = "rgba(0,0,0,0.5)";
    loadingOverlay.style.zIndex = "1000";
    loadingOverlay.style.display = "flex";
    loadingOverlay.style.justifyContent = "center";
    loadingOverlay.style.alignItems = "center";
    loadingOverlay.style.flexDirection = "column";

    // Create loading spinner
    const spinner = document.createElement("div");
    spinner.style.border = "4px solid #f3f3f3";
    spinner.style.borderTop = "4px solid #3498db";
    spinner.style.borderRadius = "50%";
    spinner.style.width = "40px";
    spinner.style.height = "40px";
    spinner.style.animation = "spin 1s linear infinite";
    spinner.style.marginBottom = "15px";

    // Create loading message
    const messageDiv = document.createElement("div");
    messageDiv.style.color = "white";
    messageDiv.style.fontSize = "16px";
    messageDiv.style.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif";
    messageDiv.textContent = message;

    // Add keyframes for spinner animation
    const style = document.createElement("style");
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);

    loadingOverlay.appendChild(spinner);
    loadingOverlay.appendChild(messageDiv);
    document.body.appendChild(loadingOverlay);
    document.body.style.overflow = "hidden";
  }

  function removeLoadingState() {
    const loadingOverlay = document.getElementById("license-loading-overlay");
    if (loadingOverlay) {
      loadingOverlay.remove();
    }
  }

  function showInvalidLicense(message) {
    removeLoadingState();
    const existingOverlay = document.getElementById("license-error-overlay");
    if (existingOverlay) {
      existingOverlay.remove();
    }

    // Full-screen blocking overlay
    const overlay = document.createElement("div");
    overlay.id = "license-error-overlay";
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100vw";
    overlay.style.height = "100vh";
    overlay.style.backgroundColor = "#ffffff";
    overlay.style.zIndex = "999999";
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";
    overlay.style.flexDirection = "column";
    overlay.style.textAlign = "center";
    overlay.style.pointerEvents = "auto";
    overlay.style.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";

    const heading = document.createElement("h1");
    heading.textContent = "🚫 License Required";
    heading.style.color = "#e74c3c";
    heading.style.fontSize = "28px";
    heading.style.marginBottom = "20px";

    const messageP = document.createElement("p");
    messageP.innerHTML = `${message}.<br><br>Please enter a valid license key in <strong>Theme Settings → License</strong> to unlock access.`;
    messageP.style.color = "#333";
    messageP.style.fontSize = "18px";
    messageP.style.lineHeight = "1.6";
    messageP.style.maxWidth = "600px";

    overlay.appendChild(heading);
    overlay.appendChild(messageP);
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";

    overlay.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }
  validateLicense(Shopify.license_key, Shopify.shop);
}
 